import { PopUp } from "components";
import { Fragment, useState } from "react";
import { BsBagPlusFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, getCartSelector, updateFromCart } from "slices/cart";
import { ProductType } from "slices/products";
import './index.scss'

export interface ProductProps {
    product: ProductType
    cartIndex: number
    id: string
}

export interface handleQtyProps {
    action: string
}

export function Product(props: ProductProps) {
    const cartItems = useSelector(getCartSelector)
    const dispatch = useDispatch()
    const [show, SetShow] = useState<boolean>(false)

    function handleAddToCart() {
        const productItem = { ...props.product, id: props.id }
        if (!props.product.stock) {
            dispatch(addToCart(productItem))
        }
    }

    function handleUpdateCart() {
        let cartItem = { ...cartItems[props.cartIndex] }
        if (props.cartIndex !== -1 && !props.product.stock) {
            cartItem.amount -= 1
            // console.log(cartItem)
            dispatch(updateFromCart(cartItem))
        }
    }

    function discounted_price() {
        return props.product.price - (props.product.price * ((props.product.discount ?? 0) / 100))
    }

    return (
        <Fragment>
            {show && (<PopUp id={props.id} SetShow={SetShow} handleAddToCart={handleAddToCart} handleUpdateCart={handleUpdateCart} product={props.product} cartIndex={props.cartIndex} />)}
            <div className="product">
                <div className="product_top" onClick={(e) => { SetShow(true) }}>
                    <img src={props.product.img} alt="" className="product_top_logo" />
                </div>
                <div className="product_bottom">
                    <span className="product_bottom-qty">{props.product.title}</span>
                    <span className="product_bottom-name">{props.product.name}</span>
                    <div className="product_bottom-price">
                        <div className="product_bottom-price-amount">
                            ${discounted_price()} <span className={props.product.discount ? "discount" : "d-none"} >${props.product.price}</span>
                        </div>
                        {props.cartIndex !== -1 ? (<div className="inc-dec">
                            <span className="dec" onClick={handleUpdateCart}>-</span>
                            <span className="qty">{cartItems[props.cartIndex].amount}</span>
                            <span className="inc" onClick={handleAddToCart}>+</span>
                        </div>) : (<i className="product_bottom-price-cart" onClick={handleAddToCart} ><BsBagPlusFill /></i>)}
                    </div>
                </div>
                {props.product.stock && (<span className="product_stock">
                    out of stock
                </span>)}
                {(props.product.discount ?? 0) > 0 && (<span className="product_discount">
                    {props.product.discount}% off
                </span>)}
            </div>
        </Fragment>
    )
}
